module.exports = __webpack_public_path__ + "media/music-4.4b6bbc3c.mp3";